import { DataParcial } from './DataParcial';

const TriviaWinner = ()=>{
    //Enable parcial data
    DataParcial();
    //Funciont general
    const button = document.querySelector('.header-trivia__content .btn');
    button.textContent = "Volver";
}

export { TriviaWinner }